import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { ListOfResults, Pagewrapper } from "../../components";
import "./index.scss";

const SearchResults = (props) => (
  <Pagewrapper {...props}>
    <Container>
      <Row className="justify-content-md-center mt-5">
        <Col sm={12}>
          <ListOfResults />
        </Col>
      </Row>
    </Container>
  </Pagewrapper>
);

export default SearchResults;
